export default __webpack_public_path__ + "static/media/plus.862f1d76.svg";